<template>
  <router-view/>
</template>

<script>


export default {
  name: 'App',
  computed: {},
  methods: {},
  mounted() {
    console.log(window.location.href);
    if (this.getUser) {
      this.initializeFirebaseListener(this.getUser.code);
    }
  }
};
</script>

<style src="./styles/theme.scss" lang="scss"/>
